import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckTickCircleBroken = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9.00033 0.542969C4.32892 0.542969 0.541992 4.32989 0.541992 9.0013C0.541992 13.6727 4.32892 17.4596 9.00033 17.4596C13.6717 17.4596 17.4587 13.6727 17.4587 9.0013C17.4587 7.42489 17.0274 5.9492 16.2764 4.68577C13.7373 6.43359 11.6238 8.73094 10.0932 11.4076L9.79375 11.9314C9.65955 12.166 9.41985 12.321 9.15077 12.3471C8.88169 12.3732 8.61668 12.2672 8.43989 12.0627L5.54428 8.71285C5.2433 8.36466 5.28158 7.83842 5.62976 7.53744C5.97795 7.23647 6.50419 7.27474 6.80517 7.62293L8.93622 10.0883C10.5546 7.41962 12.7184 5.12071 15.2876 3.34316C13.7394 1.62391 11.4961 0.542969 9.00033 0.542969Z",
		fill: "#71717A"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15.2876 3.34316C15.6593 3.75594 15.991 4.20552 16.2764 4.68577L16.9991 4.19223C17.3791 3.93267 17.4768 3.41416 17.2172 3.03409C16.9577 2.65403 16.4392 2.55634 16.0591 2.8159L15.3988 3.26688C15.3616 3.29223 15.3246 3.3176 15.2876 3.34316Z",
		fill: "#71717A"
	})]
});
const ForwardRef = forwardRef(SvgCheckTickCircleBroken);
export default ForwardRef;
